import { storyblokEditable } from "gatsby-source-storyblok"

import ArticleBanner from "@components/V2/Banners/ArticleBanner"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokArticleBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ArticleBanner>) => {
  return (
    <ArticleBanner
      heading1={blok.heading1}
      heading2={blok.heading2}
      mobileHeading1={blok.mobileHeading1}
      mobileHeading2={blok.mobileHeading2}
      ctaText={blok.ctaText}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      imageUrl={blok.image?.filename}
      imageAlt={blok.image?.alt}
      mobileImageUrl={blok.mobileImage?.filename}
      videoUrl={blok.video?.filename}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokArticleBanner
